import React, { useEffect, useState } from 'react';
import AOS from "aos";
import 'aos/dist/aos.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { Route, Routes } from 'react-router-dom';
import { usePageTracking } from './hooks/use-analytics';
import Home from './pages/home';
import Shop from './pages/shop';
import Header from './components/header';
import Footer from './components/footer';
import Instagram from './components/instagram';
import Checkout from './pages/checkout';
import OrderPurchased from './pages/order-purchased';
import Protected from './pages/protected';
import Dashboard from './pages/dashboard';
import Login from './pages/login';
import PageNotFound from './pages/not-found';
import Signup from './pages/signup';
import Orders from './pages/dashboard/orders';
import TrackOrder from './pages/dashboard/track-order';
import UserShippingAddress from './pages/dashboard/user-shipping-address';
import Settings from './pages/dashboard/settings';
import HelpInfo from './pages/help-info';
import Services from './pages/service';

function App() {
  // Initialize page tracking
  usePageTracking();

  const [isPreloaderLoaded, setIsPreloaderLoaded] = useState(false);
  useEffect(() => {
    
    const handleLoad = () => {
      setIsPreloaderLoaded(true);
      initializeSwiper();
    };

    const initializeSwiper = () => {
      AOS.init({
        duration: 1200,
        once: true
      });
    }

    if (document.readyState === 'complete') {
      handleLoad();
    } else {
      window.addEventListener('load', handleLoad);
    }

    // Cleanup
    return () => {
      window.removeEventListener('load', handleLoad);
    };

  }, []);

  
  return (
    <div className="App">
      <div 
        className={`
          preloader 
          text-white 
          fs-6 
          text-uppercase 
          overflow-hidden 
          ${isPreloaderLoaded ? 'loaded' : ''}`
        }
      ></div>
      <Header />
      <Routes>
        <Route path='/signup' index element={<Signup />} />
        <Route path='/login' index element={<Login />} />
        <Route path='/' index element={<Home />} />
        <Route path='/help/:slug' element={<HelpInfo />} />
        <Route path='/shop' element={<Shop />} />
        <Route path='/services' element={<Services />} />
        <Route path='/checkout' element={<Checkout />} />
        <Route path='/order-purchased' element={<OrderPurchased />} />
        <Route path='/customer' element={<Protected />}>
          <Route index element={<Dashboard />} />
          <Route path='dashboard' element={<Dashboard />}>
            <Route index element={<Orders />} />
            <Route path='orders' element={<Orders />} />
            <Route path='track-order' element={<TrackOrder />} />
            <Route path='shipping-address' element={<UserShippingAddress />} />
            <Route path='settings' element={<Settings />} />
          </Route>
        </Route>
        <Route path='*' element={<PageNotFound />} />
      </Routes>
      <Instagram />
      <Footer />
    </div>
  );
}

export default App;
